/**
 * The 1–2 initials shown in the avatar chip: the first letter of the FIRST name + the first letter of the LAST name
 * ("Michael Demel" → "MD"). A single-word display name or a username (no whitespace — ~74% of users have no name and
 * fall back to their username) yields a SINGLE initial ("superadmin" → "S").
 *
 * Presentation, so it lives with the component rather than the API — and `apps/*` may not import each other
 * (dependency-cruiser enforces it), so this could not be shared from `apps/api` even if it belonged there.
 *
 * Derived from the SAME resolved `displayName` the chip renders, so the initials can never disagree with the name
 * beside them. `Intl.Segmenter` rather than `[0]`: a name starting with an emoji or an astral-plane character would
 * otherwise yield half a surrogate pair and render as `�`.
 */
export function displayInitials(displayName: string): string {
  const firstGrapheme = (s: string) => [...new Intl.Segmenter().segment(s)][0]?.segment ?? "";
  const words = displayName.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "";
  const first = firstGrapheme(words[0]!);
  const last = words.length > 1 ? firstGrapheme(words[words.length - 1]!) : "";
  return (first + last).toLocaleUpperCase();
}
